// features/admin/adminRewardsApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface UserReward {
  id: number;
  user_id: number;
  name: string;
  user_email: string;
  points: string;
  updated_at: string;
}

export interface AdminRewardsResponse {
  error: boolean;
  total: number;
  rewards: UserReward[];
}

export interface AdminRewardsQueryParams {
  search?: string;
  page?: number;
  limit?: number;
}

export const adminRewardsApi = createApi({
  reducerPath: 'adminRewardsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3');
      headers.set('Content-Type', 'application/x-www-form-urlencoded');
      return headers;
    },
  }),
  tagTypes: ['AdminRewards'],
  endpoints: (build) => ({
    listAdminRewards: build.query<AdminRewardsResponse, void>({
      query: () => ({
        url: 'user/adminrewards',
        method: 'POST',
        body: new URLSearchParams(),
      }),
      providesTags: ['AdminRewards'],
      transformResponse: (response: any) => ({
        error: response.error || false,
        total: response.total || 0,
        rewards: response.rewards || [],
      }),
    }),
  }),
});

export const {
  useListAdminRewardsQuery,
} = adminRewardsApi;